// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see NotificationPreferencesPushOSSettingDisabledEvent
 */
export var NotificationPreferencesPushOSSettingDisabled = function () { return ({
    name: "NotificationPreferences PushOSSetting Disabled",
    parameters: {
        cdf_entity: "NotificationPreferences",
        cdf_action: "PushOSSetting",
    }
}); };
/**
 * @see NotificationPreferencesPushOSSettingEnabledEvent
 */
export var NotificationPreferencesPushOSSettingEnabled = function () { return ({
    name: "NotificationPreferences PushOSSetting Enabled",
    parameters: {
        cdf_entity: "NotificationPreferences",
        cdf_action: "PushOSSetting",
    }
}); };
/**
 * @see NotificationPreferencesSystematicPreferenceTransitionCompleteEvent
 */
export var NotificationPreferencesSystematicPreferenceTransitionComplete = function (_a) {
    var transitionTimestamp = _a.transitionTimestamp, transitionReason = _a.transitionReason;
    return ({
        name: "NotificationPreferences SystematicPreferenceTransition Complete",
        parameters: {
            cdf_entity: "NotificationPreferences",
            cdf_action: "SystematicPreferenceTransition",
            transition_timestamp: transitionTimestamp !== undefined && transitionTimestamp !== null ? transitionTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transition_reason: transitionReason !== undefined && transitionReason !== null ? transitionReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see NotificationPreferencesSystematicPreferenceTransitionSkipEvent
 */
export var NotificationPreferencesSystematicPreferenceTransitionSkip = function (_a) {
    var skipReason = _a.skipReason;
    return ({
        name: "NotificationPreferences SystematicPreferenceTransition Skip",
        parameters: {
            cdf_entity: "NotificationPreferences",
            cdf_action: "SystematicPreferenceTransition",
            skip_reason: skipReason !== undefined && skipReason !== null ? skipReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
